import React, { forwardRef } from "react";
import { defaultStyle } from "./style";
import { css } from "emotion";
import { Input as AtomicInput } from "@maxmilhas/hangar-components-atomic/public";

const Input = forwardRef((props, ref) => {
	const inputStyle = defaultStyle(props.hasError, props.type, props.shadow);
	return (
		<div
			className={css`
				${inputStyle}
			`}
		>
			<AtomicInput ref={ref} {...props} />
		</div>
	);
});
Input.displayName = "styledInput";

export default Input;